import { useContext, useState } from 'react';
import { Menu, MenuItem, ListItem, ListItemText, Divider } from '@material-ui/core';
import { ExitToApp as SignOutIcon, AccountCircle as UserMenuIcon } from '@material-ui/icons';
import { appUserContext, authContext } from 'helpers/services';


let UserMenu = () => {
    let userService = useContext(appUserContext);
    let authService = useContext(authContext);

    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);


    return (
        <>
            <ListItem id="login-menu" button onClick={(e: any) => setAnchorEl(e.currentTarget)}>
                <ListItemText primary={<UserMenuIcon />} />
            </ListItem>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem disabled>
                    {userService.currentUser?.firstName}&nbsp;{userService.currentUser?.lastName}<br />
                    {userService.currentUser?.email}
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        authService.signOut();
                    }}
                >
                    <SignOutIcon />&nbsp;&nbsp;Logout
                </MenuItem>
            </Menu>
        </>
    )
}

export default UserMenu;